module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAgMAAAAPYzcHAAAADFBMVEUAAAAAfu4Afe0AfO2nynzaAAAAA3RSTlMASePizoNQAAAANUlEQVQI12NgIADY/oPABAZuMP0ATsPECYP8/z/B9P7//1BomDhB7f/BCvcD6X9INEwcPwAAoykzcz5ylIcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/jz-2@2x.png
// module id = SLBt
// module chunks = 96